import React from 'react';
import { CircularProgress, Grid } from '@mui/material';

export const PreLoader = () => {
  return (
    <Grid container>
      <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
        <CircularProgress color="secondary" size={60} />
      </Grid>
    </Grid>
  );
};
